<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("distributorDeduction") }}</div>
      </div>
      <div>
        <b-button
          variant="default"
          to="add-distributor-deduction"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>
    <br />

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <!-- <Tooltip :title="$t('cinemadistributiondeduction')" /> -->
          </div>
        </div>
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedDistributor.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("distributor", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedDistributor"
                variant="dropdown-curve"
                class="w-100"
                name="selectdistri_1"
                id="selectdistri_1"
              >
                <b-dropdown-item
                  v-for="(Distributor, DistributorIndex) in distributors"
                  :key="DistributorIndex"
                  v-on:click="onSelectDistributor($event, Distributor)"
                  >{{ Distributor.d_company_name }}</b-dropdown-item
                >
                <!-- <b-dropdown-item v-on:click="onSelectDistributor('Spiderman')">MovieBuff</b-dropdown-item> -->
              </b-dropdown>
              <!-- <Tooltip :title="$t('distribution_distributionDeduction')" /> -->
            </div>
            <!-- <p
            v-if="submitted && selectedDistributor.length == 0"
            class="error_message"
            >{{ messagecinema }}</p>-->
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedmovie.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("movie", 1) }}</label
              >
              <b-dropdown
                :text="selectedmovie"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Movie, MovieIndex) in Movies"
                  v-on:click="onSelectMovie($event, Movie)"
                  :key="MovieIndex"
                  >{{ Movie.movie_details }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <!-- <Tooltip :title="$t('movieDistributionDeduction')" /> -->
          </div>
          <!-- <p class="error_message">
          <span v-if="submitted && selected.movie.length == 0">{{ errmsg2 }}</span>
          </p>-->
        </div>
      </div>
      <!-- <div class="col-lg-6 col-xl-3 mb-4">
        <div class="dropdown-curve-container mr-2">
          <label
            :class="getDistributorReportSelectedDistributor && getDistributorReportSelectedDistributor.length > 0 ? 'shift-up' : ''"
          >Select Distributor</label>
          <b-dropdown
            :text="getDistributorReportSelectedDistributor"
            variant="dropdown-curve"
            class="w-100"
          >
            <b-dropdown-item
              v-for="(dropdownItem,dropdownIndex) in getDistributorReportDropdownList"
              :key="dropdownIndex"
              @click="onDistributorReportDropdownHandler({ event: $event, name:'isDistributor',selectedItem: dropdownItem, index:dropdownIndex })"
            >{{ dropdownItem.d_company_name }}</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>

      <div class="col-lg-6 col-xl-3 mb-4">
        <div class="dropdown-curve-container mr-2">
          <label
            :class="getDistributorReportSelectedMovie && getDistributorReportSelectedMovie.length > 0 ? 'shift-up' : ''"
          >Select Movie</label>
          <b-dropdown
            :text="getDistributorReportSelectedMovie"
            variant="dropdown-curve"
            class="w-100"
          >
            <b-dropdown-item
              v-for="(dropdownItem,dropdownIndex) in getDistributorReportMoviesList"
              :key="dropdownIndex"
              @click="onDistributorReportDropdownHandler({ event: $event, name:'isMovie',selectedItem: dropdownItem, index:dropdownIndex })"
            >{{ dropdownItem.movie_title }}</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>-->
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left" style="width: 120px">
              <span class="pr-5">{{ $tc("status", 2) }}</span>
            </th>
            <th>{{ $t("date") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(
              distributordeduc, distributordeducIndex
            ) in DistributorDeductions"
            :key="distributordeducIndex"
          >
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <!-- <label class="ios-switch"> -->
                <b-form-checkbox type="checkbox" class="j-checkbox" />
                <!-- <span class="switch-slider"></span>
                </label> -->

                <!-- Edit Icon with Tooltip -->
                <span
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                  v-on:click="onEditDistributorDeduction(distributordeduc)"
                >
                  <span class="edit-pen blue-icon"></span>
                </span>

                <!-- View Icon with Tooltip -->
                <span
                  v-b-tooltip="'View'"
                  tabindex="0"
                  v-on:click="onViewDistributorDeduction(distributordeduc)"
                >
                  <span class="icon-eye blue-icon"></span>
                </span>
              </div>
            </td>

            <td>{{ distributordeduc.dd_date | dateparse }}</td>

            <!-- <td>
              <div class="d-flex align-items-center justify-content-end">
                <label class="ios-switch">
                  <input type="checkbox" class="ios-checkbox" />
                  <span class="switch-slider"></span>
                </label>

                <b-dropdown variant="edit" class="ml-4">
                  <b-dropdown-item v-on:click="onEditDistributorDeduction(distributordeduc)">
                    <span class="edit-pen"></span>
                    {{ $t('edit') }}
                  </b-dropdown-item>

                  <b-dropdown-item v-on:click="onViewDistributorDeduction(distributordeduc)">
                    <span class="icon-eye"></span>
                    {{ $t('view') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>-->
  </div>
</template>



<script>
import moment from "moment";
import DistributorService from "@/services/DistributorService";
import CinemasService from "@/services/CinemasService";
import MovieService from "@/services/MovieService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      isRoleID: true,
      selectedCinema: "",
      Movies: [],
      Cinemas: [],
      selectedmovie: "",
      distributors: [],
      selectedDistributor: "",
      selectedDistributorShareType: "Select Distributor Share Type",
      DistributorDeductions: [],
      distributorDeductions: {
        distributor_id: null,
        cinema_id: null,
        cinema_id_list: [],
        movie_details_id: null,

        dd_date: null,
        dd_is_active: "Y",
        created_by: null,
        created_at: null,
      },
      DistributorMovies: [],
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.cinema_manager_add_edit_disabled = roleid;
    if (true) {
      this.isRoleID = false;
    }

    this.getCinemaList(obj);
    this.getDistributorsList();
  },
  methods: {
    onEditDistributorDeduction: function (dis_detection) {
      this.$router.push({
        path: "/distributor/edit-distributor-deduction",
        query: {
          dd_date: dis_detection.dd_date,
          cinema_id: this.distributorDeductions.cinema_id,
          distributor_id: this.distributorDeductions.distributor_id,
          movie_details_id: this.distributorDeductions.movie_details_id,
        },
      });
    },
    onViewDistributorDeduction: function (dis_detection) {
      this.$router.push({
        path: "/distributor/view-distributor-deduction",
        query: {
          dd_date: dis_detection.dd_date,
          cinema_id: this.distributorDeductions.cinema_id,
          distributor_id: this.distributorDeductions.distributor_id,
          movie_details_id: this.distributorDeductions.movie_details_id,
        },
      });
    },
    getDistributionDeduction: function () {
      if (
        this.distributorDeductions.distributor_id &&
        this.distributorDeductions.cinema_id &&
        this.distributorDeductions.movie_details_id
      ) {
        let payload = {
          cinema_id: this.distributorDeductions.cinema_id,
          movie_details_id: this.distributorDeductions.movie_details_id,
          distributor_id: this.distributorDeductions.distributor_id,
        };
        DistributorService.GetAllDistributorDeductions(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.DistributorDeductions = data.Records;
            } else {
              if (data.message) {
                this.$toasted.show(data.message);
              } else {
                this.$toasted.show("No Distributor Deductions found");
              }
              this.DistributorDeductions = [];
            }
          })
          .catch(this._CatchError);
      } else {
        this.$toasted.show("Please select distributors and cinemas and movie");
      }
    },
    getDistributorsList: function () {
      let body = {
        tableName: "ms_distributors",
        d_is_active: "Y",
      };
      DistributorService.GetActiveDistributors(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0)
            this.distributors = data.Records || [];
          else this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    onSelectDistributor: function (event, params) {
      this.selectedDistributor = params.d_company_name;
      this.distributorDeductions.distributor_id = params.d_id;
      this.getMoviesList();
    },
    getCinemaList: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                let cinema = {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                };

                this.onSelectCinema(null, cinema);
              }
            });
          } else {
            // Show Error Message
            this.$toasted.show(data.message);
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    onSelectCinema: function (event, params) {
      this.selectedCinema = params.cine_name;
      this.distributorDeductions.cinema_id = params.cine_id;
    },
    onSelectMovie: function (event, params) {
      this.selectedmovie = params.movie_details;
      this.distributorDeductions.movie_details_id = params.md_id;
      this.getDistributionDeduction();
    },

    getMoviesList: function () {
      if (
        this.distributorDeductions.distributor_id &&
        this.distributorDeductions.cinema_id
      ) {
        let payload = {
          distributor_id: this.distributorDeductions.distributor_id,
          cinema_id: this.distributorDeductions.cinema_id,
        };
        DistributorService.GetDistributorDeductionsMovies(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              data.Records.length > 0 ? (this.Movies = data.Records) : "";
            } else data && data.message ? this.$toasted.show(data.message) : "";
          })
          .catch(this._CatchError);
      } else {
        this.$toasted.show("Please select distributors and cinemas");
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorDeduction/distributorDeduction.vue